const isProd = process.env.CONFIG === 'prod';
const atcBaseUrl = isProd ? 'https://www.autotrader.com' : 'https://test.autotrader.com';
const psxStaticBaseUrl = `${atcBaseUrl}/psx-static/main/psx-react-web`;
const heroImageDesktopUrl = `${psxStaticBaseUrl}/psx-hero-2x.webp`;
const kbbAndAtcLogoImgUrl = 'combinedlanding-logos.webp';
const psxLocationEligibilityBaseUrl = process.env.PSX_LOCATION_ELIGIBILITY_BASE_URL || `${atcBaseUrl}/marketplace`;
const psxPopularListingsBaseUrl = `${atcBaseUrl}/marketplace`;
const popularListingsPath = '/api/listings/search/recentlistings?status=active&page_size=15&has_images=true&availability=public';
const staticUrl = process.env.STATIC_URL && '/';
const optimizelySdkKey = isProd ? '7Cv1BBWA6VS6q8wsJyeE9' : 'MX5P86GRKya36dYU2Z37W';
const blpRedesignDefault = (process.env.BLP_REDESIGN_DEFAULT ?? 'true').toLowerCase() === 'true';
const regionShort = process.env.REGION_SHORT || 'use1';
const stackId = process.env.STACK_ID;
const shopByOwnerBaseUrl = `${atcBaseUrl}/cars-for-sale/by-owner`;
export {
  isProd,
  atcBaseUrl,
  psxStaticBaseUrl,
  heroImageDesktopUrl,
  kbbAndAtcLogoImgUrl,
  staticUrl,
  psxLocationEligibilityBaseUrl,
  psxPopularListingsBaseUrl,
  popularListingsPath,
  optimizelySdkKey,
  blpRedesignDefault,
  regionShort,
  stackId,
  shopByOwnerBaseUrl,
};
